// extracted by mini-css-extract-plugin
export var container = "_gm-0";
export var content = "_gm-3";
export var customerTitle = "_gm-4";
export var empty = "_gm-5";
export var gray = "_gm-6";
export var header = "_gm-7";
export var info = "_gm-8";
export var loading = "_gm-2";
export var loadingCard = "_gm-9";
export var oneLine = "_gm-a";
export var personName = "_gm-e";
export var pillContainer = "_gm-b";
export var selected = "_gm-1";
export var text = "_gm-c";
export var twoLines = "_gm-d";
export var unread = "_gm-f";
export var unreadIndicator = "_gm-g";